import * as yup from 'yup'
import {
  getNameSchema,
  getEmailSchema,
  getOptionalPhoneNumberSchema,
} from 'src/deps'

export const userInviteFormschema = props => {
  let schemaData = {}

  if (props?.isFromUserListCard === false) {
    schemaData = Object.assign(
      {},
      getNameSchema({ inputName: 'firstName' }),
      getNameSchema({ isLastName: true, inputName: 'lastName' }),
      getEmailSchema({ inputName: 'email' }),
      getOptionalPhoneNumberSchema({ inputName: 'phoneNumber' })
    )
  } else {
    schemaData = Object.assign({}, getEmailSchema({ inputName: 'email' }))
  }

  return yup.object(schemaData)
}
